<template>
  <component :is="`cms-ugc-${provider}`" :content />
</template>

<script lang="ts" setup>
import type { UGCContent, UGCSocialNativeContent } from '#types/components/cms/ugc'

defineProps<{ content: UGCContent | UGCSocialNativeContent }>()

const { provider } = useAppConfig().components.cms.ugc
</script>
